import { response } from "app/helpers/commonInterface";
import {
  GET_COMPLETED_TASK_REPORT_LIST_FAILURE,
  GET_COMPLETED_TASK_REPORT_LIST_REQUEST,
  GET_COMPLETED_TASK_REPORT_LIST_SUCCESS,
  GET_TASK_REPORT_LIST_FAILURE,
  GET_TASK_REPORT_LIST_REQUEST,
  GET_TASK_REPORT_LIST_SUCCESS,
} from "../actionTypes";
import { taskData } from "./taskDataInterface";

export interface taskReportListState {
  loading: boolean;
  taskDetails: response<taskData[]>;
  error: string;
}

export interface CompletedTaskReportListState {
  loading: boolean;
  completedTaskDetails: response<taskData[]>;
  error: string;
}

interface action {
  type: string;
  payload: any;
}

const initialState: taskReportListState = {
  loading: false,
  taskDetails: {},
  error: "",
};

const initialStates: CompletedTaskReportListState = {
  loading: false,
  completedTaskDetails: {},
  error: "",
};

export const getTaskReportListReducer = (
  state = initialState,
  action: action
) => {
  switch (action.type) {
    case GET_TASK_REPORT_LIST_REQUEST:
      return {
        loading: true,
      };
    case GET_TASK_REPORT_LIST_SUCCESS:
      return {
        loading: false,
        taskDetails: action.payload,
        error: "",
      };
    case GET_TASK_REPORT_LIST_FAILURE:
      return {
        loading: false,
        taskDetails: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

export const getCompletedTaskReportListReducer = (
  state = initialStates,
  action: action
) => {
  switch (action.type) {
    case GET_COMPLETED_TASK_REPORT_LIST_REQUEST:
      return {
        loading: true,
      };
    case GET_COMPLETED_TASK_REPORT_LIST_SUCCESS:
      return {
        loading: false,
        completedTaskDetails: action.payload,
        error: "",
      };
    case GET_COMPLETED_TASK_REPORT_LIST_FAILURE:
      return {
        loading: false,
        completedTaskDetails: {},
        error: action.payload,
      };
    default:
      return state;
  }
};
